import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import MetFamilyRelationship from './met-family-relationship';
import MetFamilyRelationshipDetail from './met-family-relationship-detail';
import MetFamilyRelationshipUpdate from './met-family-relationship-update';
import MetFamilyRelationshipDeleteDialog from './met-family-relationship-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={MetFamilyRelationshipUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={MetFamilyRelationshipUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={MetFamilyRelationshipDetail} />
      <ErrorBoundaryRoute path={match.url} component={MetFamilyRelationship} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={MetFamilyRelationshipDeleteDialog} />
  </>
);

export default Routes;
